import i18n from '../i18n';

export function englishTimeToSwedishTime(time) {
  if (time === 'minutes') {
    return 'minuter';
  }

  if (time === 'hours') {
    return 'timmar';
  }
}

export function blockNoteToSwedish(label) {
  return DONT_REMOVE_ME[label] || label;
}

const DONT_REMOVE_ME = {
  minuter: i18n.t('minuter'),
  timmar: i18n.t('timmar'),
  'Heading 1': i18n.t('Rubrik 1'),
  'Heading 2': i18n.t('Rubrik 2'),
  'Heading 3': i18n.t('Rubrik 3'),
  'Numbered List': i18n.t('Numrerad lista'),
  'Bullet List': i18n.t('Punktlista'),
  Paragraph: i18n.t('Paragraf'),
  Quote: i18n.t('Citat'),
  Code: i18n.t('Kod'),
  Table: i18n.t('Tabell'),
  Image: i18n.t('Bild'),
  Video: i18n.t('Video'),
  Audio: i18n.t('Ljud'),
  File: i18n.t('Fil'),
  Link: i18n.t('Länk'),
  Embed: i18n.t('Bädda in'),
  Block: i18n.t('Block'),
  Text: i18n.t('Text'),
  'Used for a top-level heading': i18n.t(
    'Används för en rubrik på översta nivån'
  ),
  'Used for key sections': i18n.t('Används för nyckelsektioner'),
  'Used for subsections and group headings': i18n.t(
    'Används för underavsnitt och gruppöverskrifter'
  ),
  'Used to display a numbered list': i18n.t(
    'Används för att visa en numrerad lista'
  ),
  'Used to display an unordered list': i18n.t(
    'Används för att visa en punktlista'
  ),
  'Used for the body of your document': i18n.t(
    'Används för kroppen av ditt dokument'
  ),
  'Used for for tables': i18n.t('Används för tabeller'),
  'Insert an image': i18n.t('Infoga en bild'),
  Headings: i18n.t('Rubriker'),
  'Basic blocks': i18n.t('Grundläggande block'),
  Advanced: i18n.t('Avancerad'),
  Media: i18n.t('Media'),
  Today: i18n.t('Idag'),
  Yesterday: i18n.t('Igår'),
  'This week': i18n.t('Denna vecka'),
  'Last week': i18n.t('Förra veckan'),
  'This month': i18n.t('Denna månad'),
  'Last month': i18n.t('Förra månaden'),
  'Tänker...': i18n.t('Tänker...'),
  'Söker...': i18n.t('Söker...'),
  'Organiserar...': i18n.t('Organiserar...'),
  'Startar...': i18n.t('Startar...'),
  enterprise: i18n.t('Enterprise'),
  stripe: i18n.t('Pro'),
  trial: i18n.t('Prova på'),
};
